module.exports = __webpack_public_path__ + "static/media/myanimoji.1889f7cf.png";